// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"11a8cc22","150":"b6da2d2b","925":"11a8cc22"}[chunkId] + ".chunk.css";
};